import PropTypes from 'prop-types'
import classnames from 'classnames'
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'

// Utils
import { useFormatMessage } from 'src/providers/intl'

// Selectors
import { selectValuationBounds } from 'src/store/selectors/home'
import { selectShouldDisplayWhatSellFor } from 'src/store/selectors/display'

// Components
import { Panel, Text, Format } from 'src/Components'
import Question from 'src/Components/shared/Questions/QuestionSingleContainer'

// Constants
import { WHAT_TO_SELL_FOR_TOPIC_KEY } from 'src/constants/topicKeys'
import { QUESTIONS } from 'src/constants/messages'

// Styles
import styles from './WhatSellFor.module.scss'

const WhatSellFor = ({ className }) => {
  const intlFormat = useFormatMessage()

  const bounds = useSelector(selectValuationBounds) || {}
  const display = useSelector(selectShouldDisplayWhatSellFor)

  return (
    <Panel
      data-qa='what-sell-for'
      className={classnames(styles.panel, !display && styles.hide, className)}
    >
      <Text
        upperspaced
        variant='neutralCool'
        variantCount='600'
        size='s'
        className={styles.title}
      >
        <FormattedMessage
          id='ShouldYouSell.WhatSellFor.title'
          defaultMessage='What could you sell for?'
        />
      </Text>
      <Text
        size='m'
        variant='neutralCool'
        variantCount='900'
        className={styles.description}
      >
        <FormattedMessage
          id='ShouldYouSell.WhatSellFor.description'
          defaultMessage='Based on recent nearby sales, you might be able to sell for'
        />
      </Text>
      <Text size='xl' variant='primary' className={styles.numbers}>
        <Format.Currency abbreviate value={bounds.low} />
        {' - '}
        <Format.Currency abbreviate value={bounds.high} />
      </Text>
      <Question
        questionTopic={intlFormat(QUESTIONS.whatSellForTopic)}
        placeholder={intlFormat(QUESTIONS.whatSellFor)}
        questionTopicKey={WHAT_TO_SELL_FOR_TOPIC_KEY}
      />
    </Panel>
  )
}

WhatSellFor.propTypes = {
  className: PropTypes.string,
}

export default WhatSellFor
